import React, { useEffect, useRef, useState } from "react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { stats } from "../../mock";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        const dur = 1400; const start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setN(Math.round(eased * value));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        obs.unobserve(el);
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);
  return (
    <span ref={ref} className="font-serif text-4xl lg:text-5xl text-lybl-blue">
      {n.toLocaleString()}<span className="text-lybl-blueSoft">{suffix}</span>
    </span>
  );
}

export default function Stats() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 text-center">
        <Reveal><Eyebrow color="blue">{stats.eyebrow}</Eyebrow></Reveal>
        <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink text-balance">{stats.title}</h2></Reveal>
        <Reveal delay={140}><p className="mt-5 max-w-2xl mx-auto text-lybl-muted text-lg">{stats.subtitle}</p></Reveal>
        <Reveal delay={200}>
          <div className="mt-12 rounded-3xl bg-lybl-lavender/60 ring-1 ring-lybl-blue/10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 divide-y md:divide-y-0 md:divide-x divide-lybl-blue/10 overflow-hidden">
            {stats.items.map((s) => (
              <div key={s.label} className="px-6 py-8 flex flex-col items-center gap-3">
                <Counter value={s.value} suffix={s.suffix} />
                <span className="h-px w-6 bg-lybl-blue/30" />
                <p className="text-[13px] font-medium text-lybl-ink/70 leading-snug">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
